module.exports = __webpack_public_path__ + "img/p-title2.d07e64c0.svg";